import React from "react";

import Header from "@amzn/awsui-components-react/polaris/header";

import { usePageHeader } from "./hooks";
import Info from "features/info";
import styles from "./style.module.scss";

const PageHeader: React.FC = () => {
  const { pageHeader } = usePageHeader();
  const { title, description, hasInfo, help, actions, hideTitle } = pageHeader;

  if (hideTitle) {
    return null;
  }

  return (
    <Header
      variant="h2"
      className={styles.pageHeader}
      description={description}
      info={hasInfo && <Info help={help} />}
      actions={actions}
      data-testid="page-header"
    >
      {title}
    </Header>
  );
};

export default PageHeader;
